import '../pages/solution/style.less'

// 滚动记录滚动条位置到 sessionStorage
window.addEventListener('scroll', function () {
  sessionStorage.setItem('scrollPosition', window.scrollY.toString())
})
// 文档加载完成后，恢复滚动条位置
document.addEventListener('DOMContentLoaded', function () {
  const scrollPosition = sessionStorage.getItem('scrollPosition')
  if (scrollPosition) {
    window.scrollTo(0, parseInt(scrollPosition))
  }
})

import React from 'react'
import ReactDOM from 'react-dom/client'

import { getInitData } from './public/getInitData'
import { SolutionList, type SolutionListProps } from '../pages/solution'

if (location.pathname.includes('/solution')) {
  const rootEl = document.getElementById('root')!
  const root = ReactDOM.createRoot(rootEl)
  const props = getInitData<SolutionListProps>()
  root.render(
    <React.StrictMode>
      <SolutionList {...props} />
    </React.StrictMode>
  )
}
